import React, { useState } from 'react';
import styled from 'styled-components';
import { FaCheckCircle } from 'react-icons/fa';


const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center; /* Aligns the modal to the bottom of the page */
  backdrop-filter: blur(5px);
`;

const Modal = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 10px 10px 0 0; /* Rounds the top corners */
  max-width: 500px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1000;
  margin-bottom: 80px; /* Adds spacing from the bottom */
`;

const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 1.25rem; /* Smaller font size */
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const Input = styled.input`
  width: calc(100% - 20px);
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 0.9rem; /* Smaller font size */
`;

const Button = styled.button`
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-top: 10px;
  font-size: 0.9rem; /* Smaller font size */

  &:hover {
    background-color: #0056b3;
  }

  &:not(:last-child) {
    margin-right: 10px;
  }
`;

const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
`;

const CheckIcon = styled(FaCheckCircle)`
  color: #28a745;
  font-size: 40px; /* Smaller icon size */
  margin-bottom: 20px;
`;


const PropertyRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px; /* Optional, controls the spacing between the rows */
  justify-content: space-between; /* Ensures there is space between the label and the paragraph */
  width: 100%; /* Ensures full-width of the row */
`;

// Styled label element
const Label = styled.label`
  margin-right: 10px; /* Space between the label and paragraph */
  font-weight: bold;
  color: #333;
  white-space: nowrap; /* Prevents label text from wrapping */
  flex-shrink: 0; /* Prevents label from shrinking */
`;

// Styled paragraph element
const PropertyText = styled.p`
  margin: 0;
  color: #555;
  white-space: nowrap; /* Prevents paragraph text from wrapping */
  flex-grow: 1; /* Makes the paragraph take up the remaining space */
`;




const ReservationSummaryModal = ({ isModalOpen,
    id,
    onClose,
    occupants,
    includeOvernight,
    includeSaturdays,
    includeSundays,
    checkInDate,
    checkOutDate,
    checkInTime,
    checkOutTime, totalHours, totalCost, closeModal }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  


  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('jwt_token'); // Retrieve token from localStorage
  
    // Helper function to format the date as YYYY-MM-DD
    const formatDate = (date) => {
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };
  
    // Helper function to format the time as HH:MM:SS
    const formatTime = (time) => {
      const t = new Date(time);
      return `${String(t.getHours()).padStart(2, '0')}:${String(t.getMinutes()).padStart(2, '0')}:${String(t.getSeconds()).padStart(2, '0')}`;
    };
  
    // Build the request body
    const requestBody = {
      listing_id: id,
      start_date: formatDate(checkInDate), // Format start date
      end_date: formatDate(checkOutDate),  // Format end date
      payment_proof_urls: "", // S3 URLs for payment proof
      number_of_occupants: occupants,
      total_payment: totalCost,
      full_day: includeOvernight, // Indicates if it's a full-day reservation
      checkin_time: formatTime(checkInTime), // Format check-in time
      checkout_time: formatTime(checkOutTime), // Format check-out time
      daily_duration: 0.0,
      include_saturday: includeSaturdays,
      include_sunday: includeSundays
    };
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/reservation/create`, {
      // const response = await fetch('http://localhost:8000/reservation/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Authorization header
        },
        body: JSON.stringify(requestBody), // Convert request body to JSON
      });
  
      if (!response.ok) {
        throw new Error('Failed to make the reservation');
      }
  
      const data = await response.json();
      console.log('Reservation successful:', data);
  
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        closeModal();
      }, 3000);
    } catch (error) {
      console.error('Error during reservation:', error);
    }
  };
  
  
  const convertDate = (inputDate) => {
    const newDate = new Date(inputDate);
    return String(newDate.getDate()).padStart(2, '0') + "-" +
       String(newDate.getMonth() + 1).padStart(2, '0') + "-" +
       String(newDate.getFullYear());
  }

  const convertTime = (inputTime) => {
    const newTime = new Date(inputTime);
    return String(newTime.getHours()).padStart(2, '0') + ":" +
       String(newTime.getMinutes()).padStart(2, '0');
  }
  
  return (
    <Overlay onClick={closeModal}>
      <Modal onClick={(e) => e.stopPropagation()}>
        {!showSuccess ? (
          <>
            <Title>Reservation Summary</Title>
              <p>Please make sure the information given under is correct</p>
              <PropertyRow>
                <Label>Stay overnight:</Label>
                <PropertyText>{includeOvernight ? "Yes" : "No"}</PropertyText>
              </PropertyRow>
              <PropertyRow>
                <Label>Number of Guests:</Label>
                <PropertyText>{occupants}</PropertyText>
              </PropertyRow>
              {includeOvernight ?
                <> 
                  <PropertyRow>
                    <Label>Check-In Date:</Label>
                    <PropertyText>{convertDate(checkInDate)}</PropertyText>
                  </PropertyRow>
                  <PropertyRow>
                    <Label>Check-in Time:</Label>
                    <PropertyText>{convertTime(checkInTime)}</PropertyText>
                  </PropertyRow>
                  <PropertyRow>
                    <Label>Check-Out:</Label>
                    <PropertyText>{convertDate(checkOutDate)}</PropertyText>
                  </PropertyRow>
                  <PropertyRow>
                    <Label>Check-out Time:</Label>
                    <PropertyText>{convertTime(checkOutTime)}</PropertyText>
                  </PropertyRow>
                </>
                : 
                <>
                  <PropertyRow>
                    <Label>Starting Date:</Label>
                    <PropertyText>{convertDate(checkInDate)}</PropertyText>
                  </PropertyRow>
                  <PropertyRow>
                    <Label>Ending Date:</Label>
                    <PropertyText>{convertDate(checkOutDate)}</PropertyText>
                  </PropertyRow>
                  <PropertyRow>
                    <Label>Check-in Time:</Label>
                    <PropertyText>{convertTime(checkInTime)}</PropertyText>
                  </PropertyRow>
                  <PropertyRow>
                    <Label>Check-out Time:</Label>
                    <PropertyText>{convertTime(checkOutTime)}</PropertyText>
                  </PropertyRow>
                  <PropertyRow>
                    <Label>Include Saturdays:</Label>
                    <PropertyText>{includeSaturdays ? "Yes" : "No"}</PropertyText>
                  </PropertyRow>
                  <PropertyRow>
                    <Label>Include Sundays:</Label>
                    <PropertyText>{includeSundays ? "Yes" : "No"}</PropertyText>
                  </PropertyRow>
                </>
              }

            <Button type="button" onClick={handleSubmit}>Confirm Reservation</Button>
            <Button type="button" onClick={closeModal}>Cancel</Button>
          </>
        ) : (
          <SuccessMessage>
            <CheckIcon />
            <h3>Your reservation has been successfully submitted!</h3>
          </SuccessMessage>
        )}
      </Modal>
    </Overlay>
  );
};

export default ReservationSummaryModal;
